export default {
  newspaperPdfs: state => state.newspaperPdfs,
  newspaperPdfInfos: state => state.newspaperPdfInfos,
  totalPages: state => state.totalPages
}
